export default {"src":"/_next/static/media/hardlopen.68d12619.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};